module.exports = __webpack_public_path__ + "img/中華電信市話.776aaec6.png";